var map = {
	"./01-convert-binary-short-name-setting.js": "./src/migrations/01-convert-binary-short-name-setting.js",
	"./02-store-settings-in-overlayplugin.js": "./src/migrations/02-store-settings-in-overlayplugin.js",
	"./03-convert-light-theme.js": "./src/migrations/03-convert-light-theme.js",
	"./04-convert-spell-layout.js": "./src/migrations/04-convert-spell-layout.js",
	"./05-copy-spell-tts.js": "./src/migrations/05-copy-spell-tts.js",
	"./06-change-critical-hp-setting-key.js": "./src/migrations/06-change-critical-hp-setting-key.js",
	"./07-convert-auto-hide-to-options.js": "./src/migrations/07-convert-auto-hide-to-options.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/migrations sync recursive ^\\.\\/.*\\.js$";